import React from "react"

const TermsAndConditions = () => {
  return (
    <div className="page">
      <h1 className="page-title">
        Terms and Conditions of ETR Connect ("Terms and Conditions")
      </h1>
      <p className="sub-header">
        THIS IS A BINDING CONTRACT. PLEASE READ CAREFULLY.
      </p>
      <p>
        By accepting these terms and conditions ("Terms & Conditions"), or
        providing any services to Aptiviti, Inc. (“ETR” “we” and “us”) or its
        clients, you (the “Advisor”) agree that these Terms & Conditions govern
        your participation in the ETR Connect expert network (“ETR Connect”)
      </p>

      <h3>Overview and Activities</h3>
      <p>
        ETR Connect is comprised of professionals and consultants in various
        industries and specialties who educate and share insights with financial
        and business leaders, professionals, and other organizations
        (individually, "Client," and collectively, "Clients").
      </p>
      <p>
        ETR provides opportunities for Advisors to connect with Client(s) to
        participate in consultation projects via telephone (hereinafter referred
        to as "Projects").
      </p>

      <h3>Membership Policies</h3>
      <p>
        As an Advisor, you will be an independent contractor, and not an
        employee, of ETR. You will have no authority to act on behalf of ETR or
        the Clients. You will not be eligible for any ETR or Client employment
        benefits based on your participation in ETR Connect and you shall not
        identify any Client or ETR as your employer. You agree that you are
        joining ETR Connect in your individual capacity and not as a
        representative of any other company or organization, except as otherwise
        agreed in writing between such organization and ETR.
      </p>

      <p>
        You may only join ETR Connect if you are permitted to do so and have
        obtained all necessary consents or waivers. Prior to joining ETR Connect
        you must review employment agreements, employee manuals, codes of
        conduct, consulting agreements and other similar policies and
        agreements, (if any), to which you are a party to ensure you are allowed
        to participate in ETR Connect. You should also consider contacting
        appropriate persons within the firm(s) you have consulted for or your
        organization (if applicable) to confirm that your participation is
        permissible and to receive any consents required. It is your
        responsibility to determine whether it is appropriate for you to join
        ETR Connect. You will be free to start or cease performing services at
        any time.
      </p>
      <p>
        If you are unsure about your ability to comply with these Terms &
        Conditions, then you must decline to participate in ETR Connect.
      </p>

      <p>
        In addition to accepting and abiding by these Terms & Conditions, you
        will be required to complete the ETR Connect MNPI Training Module.
      </p>

      <p>
        While there may be many limitations on the scope of your participation
        and subjects you may discuss depending upon your particular
        circumstances, you specifically agree that at a minimum you shall not do
        any of the following at any time in connection with a Project or
        otherwise in connection with your participation in ETR Connect:
      </p>

      <ul>
        <li>
          Disclose material, nonpublic information about a public company;
        </li>
        <li>
          Disclose information that you have a duty or have agreed to keep
          confidential (e.g., by agreement, employer policy, fiduciary duty,
          NDA, etc.);
        </li>
        <li>
          Disclose information that you obtained from any person who expects you
          to keep it confidential or that you believe to be confidential;
        </li>
        <li>
          Participate in any Project if doing so would violate applicable law or
          any agreement with -- or other obligation to -- any person, employer,
          former employer or other entity;
        </li>
        <li>
          Disclose any trade secrets or other proprietary information not owned
          solely by you;
        </li>
        <li>
          Consult for Clients you reasonably believe to be competitors of the
          company that employs you or on whose board of directors you serve; or
        </li>
        <li>
          Give investment advice, including without limitation, rating or
          recommending any security, providing advice as to the value of any
          security, or providing any advice regarding the advisability of
          investing in, purchasing, or selling any security.
        </li>
      </ul>

      <p>You further agree that:</p>
      <ul>
        <li>
          if you are an employee or director of a company, you will decline to
          participate in Projects where the topic is that company, and that you
          will not discuss or disclose information about that company, such as
          its performance, strategy, or products, without the express written
          consent of the company;
        </li>

        <li>
          if you are an auditor or former auditor, you will not consult about
          organizations that you currently audit or have audited in the last
          three years;
        </li>

        <li>
          if you have worked in the accounting or finance department of a
          company within the last six months, you will not discuss accounting or
          financial issues relating to that company or its affiliates;
        </li>

        <li>
          if you are a director, officer or other employee of an entity issuing
          securities in an initial public offering (IPO), you will decline all
          Project invitations until the commencement of such offering;
        </li>

        <li>
          if you are a director, officer or other employee of an entity that has
          made or is the subject of a tender offer, or you are at an entity that
          has acted on behalf of such a company in connection with such tender
          offer, you will decline all Project invitations while the tender offer
          process is taking place;
        </li>

        <li>
          if you are a lawyer, you will not give legal advice in connection with
          a Project and will not establish an attorney-client relationship with
          Clients through Projects; and
        </li>

        <li>
          if you are an employee or agent of a public international organization
          (e.g., WHO, World Bank, United Nations, etc.) or government
          owned/controlled organization or are a government official or
          government agency official, member of party, or candidate, whether in
          the U.S. or elsewhere, you will not discuss legislation, regulation,
          policy, contracts or other business that you are in a position to vote
          upon or otherwise influence.
        </li>
      </ul>

      <p>
        You further represent that you have not been included on the Excluded
        Parties List System maintained by the GSA or the Specially Designated
        Nationals list maintained by the U.S. Department of Treasury's Office of
        Foreign Assets Control or any other similar list, domestic or foreign,
        and if your status shall change with respect to this representation, you
        shall immediately notify ETR of such event.
      </p>

      <p>
        If you become concerned with the nature of any inquiry or Project by a
        Client, you must discontinue your participation and notify ETR
        immediately by emailing connect@etr.ai.
      </p>

      <p>
        You agree to cooperate fully in any ETR inquiry concerning actual,
        alleged, or potential violations of or compliance with these Terms &
        Conditions, including but not limited to providing documentation to
        support the services you provided, in connection with any government
        investigation and/or with respect to payment issues.
      </p>

      <h3>Assignment, Acceptance & Scope of Projects</h3>

      <p>
        Your participation in Projects is always at your discretion. ETR makes
        no representation regarding the frequency, quantity or type of
        invitations to Projects you will receive or in which you will be chosen
        to participate. Unless otherwise agreed in writing by ETR or as
        otherwise stated in any Project invitation, you will only be compensated
        for the time you spend interacting with Clients on Projects at your
        agreed rate and you will not be compensated for preparation time, wait
        time or time set aside if a Project with a Client does not occur. You
        may not assign Projects or delegate any portion of your work thereon to
        others (including without limitation to any other employees of your
        firm) without ETR’s prior written consent.
      </p>

      <p>
        All interactions must be set up through ETR or its systems. If a Client
        contacts you without having arranged the Project through ETR, and you
        consult with the Client, you are not eligible for payment from ETR, even
        if the call is a follow-up to a recent Project that was arranged through
        ETR.
      </p>

      <h3>Payment to Advisors</h3>

      <p>
        Advisors will be paid based on their hourly rate. Further information
        regarding payments can be found at{" "}
        <span>ETR Connect Advisor Information and Payment</span>.
      </p>

      <p>
        Advisor may terminate any Project at any point where they reasonably
        believe that a question raised seeks to elicit an answer that may cause
        them to violate a duty of confidentiality owed to a third party,
        disclose material non-public information, or otherwise cause a violation
        of these Terms & Conditions.
      </p>

      <p>
        Payment shall only be made in U.S. currency. For Advisors based outside
        of the U.S., please take this fact and exchange rates into consideration
        in setting your hourly consultation rate.
      </p>

      <h3>Non-Solicitation of Client</h3>
      <p>
        Membership in ETR Connect is non-exclusive, and there is no minimum time
        commitment. As a condition of participation in ETR Connect, for Clients
        to whom you have been first introduced through ETR, you agree not to
        knowingly solicit Projects from or propose or agree to any kind of
        consulting or employment arrangement with such Clients without written
        permission of ETR for a period of one year from the most recent Project
        with or introduction to such Client.
      </p>

      <h3>License</h3>
      <p>
        Content you create independently of, or prior to, any Project ("Retained
        Content") remains your property and you retain all rights, title and
        interest in and to such Retained Content; however, you grant the Client
        a perpetual, world-wide, royalty- free, and transferable license to use
        any Retained Content included in any Project. Without limiting the
        foregoing, you agree that each Client is free to use any ideas,
        concepts, know-how, or techniques contained in any Content you transmit
        to that Client for any purpose whatsoever, including, but not limited
        to, developing, manufacturing and marketing products using such
        information. Any inventions, discoveries or improvements that are based
        in full or in part on any Content and information you create for a
        Client in the course of a Project, and all intellectual property rights
        in such inventions, discoveries or improvements, shall be owned entirely
        by and shall be proprietary to the Client.
      </p>

      <h3>Privacy Policy</h3>
      <p className="sub-header">
        Confidentiality of ETR and Client Information
      </p>
      <p>
        While you participate in ETR Connect and thereafter, you agree not to
        disclose or to attempt to use or personally benefit from any
        Confidential Information that is disclosed to or known by you because of
        your participation in ETR Connect until such time as the Confidential
        Information has become publicly available through no action of your own,
        except to the extent required by law or as expressly permitted by ETR
        for the purpose of facilitating a particular Project. Confidential
        Information shall include: (1) the identity of Clients (e.g., do not
        list Clients on your resume or website); (2) information about Projects;
        (3) information about any actual or potential business, investment or
        trading decisions or transactions of any Client; or (4) any other
        confidential information of ETR or its Clients. If you are compelled by
        order of a court or other governmental or legal body (or have notice
        that such an order is being sought) to divulge any Confidential
        Information to anyone other than ETR, you will promptly and diligently
        notify ETR, unless prohibited from doing so by the express terms of a
        government subpoena or court order, and will cooperate fully with ETR in
        protecting such information to the extent possible under applicable law.
      </p>

      <p>
        Notwithstanding the foregoing, if and only to the extent necessary, you
        may disclose the general topic and Client description to secure any
        required third-party consent to your participation in ETR Connect or in
        a Project prior to accepting an invitation for that Project.
      </p>

      <p>
        Note that your obligations not to use or personally benefit from
        Confidential Information as set forth above prohibit you from using
        information you learn during a Project to trade securities or make
        personal investment decisions.
      </p>

      <h3>Reliance by Clients</h3>
      <p>
        These Terms & Conditions are intended to benefit Clients and enable
        Clients to satisfy themselves that all Projects will be carried out in
        accordance with these Terms & Conditions and applicable laws and will
        not, among other things, lead to the improper disclosure of confidential
        information, including material non-public information. Clients may from
        time to time request that you confirm any part of these Terms &
        Conditions, and any additional terms or compliance policies required by
        Clients as a condition to your participation in a Project. You
        understand that other ETR Connect participants, each Client, and the
        person with whom you may engage in any Project is an intended
        beneficiary of these Terms & Conditions and the covenants and agreements
        made by you hereunder, and that Clients, as third- party beneficiaries
        of these Terms & Conditions, have the right to enforce your compliance
        with these Terms & Conditions.
      </p>

      <h3>Agreement Details</h3>

      <p className="sub-header">Right to Injunction/Limitation on Liability</p>

      <p>
        In the event that you breach, or threaten to breach, these Terms &
        Conditions, the Clients and/or ETR’s remedies at law will be inadequate
        and that Clients and/or ETR will be entitled to an injunction to prevent
        your prospective or continuing breach and to maintain the status quo
        pending arbitration provided for below.
      </p>

      <p>
        In no event shall ETR be liable to you or any other party for any
        damages resulting from or relating to your participation in ETR Connect,
        the performance of any services by you as an Advisor, or the business
        operations of ETR, including without limitation for any incidental,
        consequential, punitive or special damages regardless of the theory of
        liability and even if ETR was informed of the possibility of such
        damages. ETR agrees that for its part it shall not seek to impose on
        Advisor any liability for damages based on your performance of services
        hereunder as an Advisor, including without limitation for any
        incidental, consequential, punitive or special damages, unless such
        damages relate to or arise out of the failure of the Advisor to comply
        with these Terms & Conditions, including the guidelines and restrictions
        contained herein, or conduct or activity by the Advisor that constitutes
        gross misconduct. You are solely responsible for your actions. ETR shall
        have no obligation to defend you, provide you with legal counsel, or pay
        legal costs and expenses on your behalf.
      </p>

      <p className="sub-header">Arbitration</p>

      <p>
        Any dispute, controversy or claim, whether in tort, contract or
        otherwise, that arises from or relates to these Terms & Conditions,
        including whether the claims asserted are arbitrable, shall be
        exclusively and finally determined by arbitration before a single
        arbitrator pursuant to the rules of the American Arbitration Association
        (the "AAA") as in effect from time to time. The enforceability of this
        arbitration agreement shall be governed by the U.S. Federal Arbitration
        Act. The venue for all arbitrations shall be New York City. The language
        to be used in the arbitral proceeding will be English. Judgment upon the
        award rendered by the arbitrator may be entered by any court having
        jurisdiction thereof. Arbitration shall not be deemed a waiver of ETR’s
        right to seek injunctive relief in any court of competent jurisdiction
        as provided for in these Terms & Conditions. Each party will be
        responsible for its own legal fees, and the arbitrator may include the
        payment of attorneys' fees or expenses as a part of any award.
        Arbitrations arising from the same or related claims may be consolidated
        in one arbitral proceeding.
      </p>

      <p className="sub-header">Governing Law</p>

      <p>
        These Terms & Conditions, as well as any claims arising from or related
        thereto the Advisor’s participation in ETR Connect, whether in tort,
        contract or otherwise, are governed by New York Law without regard to
        New York's choice of law rules.
      </p>

      <p className="sub-header">Severability</p>

      <p>
        The invalidity or unenforceability of any provision of these Terms &
        Conditions shall not for those reasons alone affect the validity or
        enforceability of any other provision of these Terms & Conditions.
      </p>

      <p className="sub-header">Survival of Certain Provisions</p>

      <p>
        The provisions of the sections (including subsections) of these Terms &
        Conditions entitled Non-Solicitation of Clients, License, Privacy
        Policy, Confidentiality of ETR and Client Information, Reliance by
        Clients, and Agreement Details shall survive any termination or
        expiration of these Terms & Conditions.
      </p>

      <p className="sub-header">Termination</p>

      <p>
        You have the right to withdraw from ETR Connect at any time upon written
        notice to ETR, and ETR has the right to terminate or limit your
        membership in ETR Connect at any time and for any reason.
      </p>

      <p>
        By signing these Terms & Conditions, you acknowledge that you are making
        express representations to ETR and Clients that you will abide by all of
        your obligations and responsibilities as set forth in these Terms &
        Conditions.
      </p>
      <p>Version Date: June 1, 2021</p>
      <p>End of Terms & Conditions</p>
    </div>
  )
}

export default TermsAndConditions
